/**
 * BOUDANE WATCHES — SHOPIFY THEME JS
 * Maison Noire Design System
 */

document.addEventListener('DOMContentLoaded', function () {

  // ============================================================
  // HEADER SCROLL BEHAVIOUR
  // ============================================================
  const header = document.querySelector('.site-header');
  if (header) {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  // ============================================================
  // HERO PARALLAX + LOAD ANIMATION
  // ============================================================
  const hero = document.querySelector('.hero');
  if (hero) {
    setTimeout(() => hero.classList.add('loaded'), 100);

    const heroBg = hero.querySelector('.hero-bg');
    // Disable parallax on mobile/tablet — causes jank and iOS white flash
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    if (heroBg && !isMobile) {
      window.addEventListener('scroll', () => {
        const scrolled = window.scrollY;
        if (scrolled < window.innerHeight) {
          heroBg.style.transform = `scale(1) translateY(${scrolled * 0.3}px)`;
        }
      }, { passive: true });
    }
  }

  // ============================================================
  // MOBILE NAVIGATION
  // ============================================================
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavClose = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    if (mobileNav) mobileNav.classList.add('open');
    document.body.classList.add('nav-open');
    document.body.style.overflow = 'hidden';
    if (mobileMenuBtn) mobileMenuBtn.setAttribute('aria-expanded', 'true');
  }

  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('open');
    document.body.classList.remove('nav-open');
    document.body.style.overflow = '';
    if (mobileMenuBtn) mobileMenuBtn.setAttribute('aria-expanded', 'false');
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  // Close mobile nav on link click
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeMobileNav);
    });
  }

  // Close mobile nav on ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeCart();
    }
  });

  // ============================================================
  // CART DRAWER
  // ============================================================
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartBtns = document.querySelectorAll('.header-cart-btn, [data-open-cart]');
  const cartCloseBtn = document.querySelector('.cart-close-btn');

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer) cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer) cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ============================================================
  // PRODUCT GALLERY
  // NOTE: Gallery thumbnail switching is handled inline in product.liquid
  // using data-src and data-srcset attributes for full-resolution images.
  // Do NOT add a duplicate handler here.
  // ============================================================

  // ============================================================
  // QUANTITY SELECTOR
  // ============================================================
  const qtyBtns = document.querySelectorAll('.qty-btn');
  qtyBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.quantity-selector').querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      if (btn.dataset.action === 'plus') val = Math.min(99, val + 1);
      input.value = val;
    });
  });

  // ============================================================
  // ADD TO CART (Shopify AJAX)
  // ============================================================
  const addToCartForms = document.querySelectorAll('.product-add-to-cart-form');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      const formData = new FormData(form);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity')) || 1
          })
        });

        if (response.ok) {
          btn.textContent = 'Added!';
          showToast('Added to your cart');
          updateCartCount();
          setTimeout(() => openCart(), 400);
        } else {
          btn.textContent = 'Error — Try Again';
        }
      } catch (err) {
        btn.textContent = 'Error — Try Again';
      }

      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2500);
    });
  });

  // ============================================================
  // CART COUNT UPDATE
  // ============================================================
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = document.querySelectorAll('.cart-count');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }

  updateCartCount();

  // ============================================================
  // NEWSLETTER FORM
  // ============================================================
  const newsletterForms = document.querySelectorAll('.newsletter-form');
  newsletterForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('.newsletter-input');
      if (input && input.value) {
        showToast('Thank you for joining the inner circle.');
        input.value = '';
      }
    });
  });

  // ============================================================
  // FAQ ACCORDION
  // ============================================================
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    if (question) {
      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        faqItems.forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    }
  });

  // ============================================================
  // SCROLL ANIMATIONS
  // ============================================================
  const fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    fadeEls.forEach(el => observer.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('visible'));
  }

  // ============================================================
  // ACTIVE NAV LINK
  // ============================================================
  const navLinks = document.querySelectorAll('.header-nav a');
  const currentPath = window.location.pathname;
  navLinks.forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

  // ============================================================
  // TOAST NOTIFICATION
  // ============================================================
  function showToast(message) {
    let toast = document.querySelector('.success-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'success-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3000);
  }

  // Page enter animation
  document.body.classList.add('page-enter');

});
